module.exports = __webpack_public_path__ + "static/img/ms.9e869fee.svg";